/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function ContactWidgetHelp(props) {
    return (
        <SvgIcon {...props}>
            <symbol id="a" viewBox="-6 -10 12 20">
                <path d="M.882-4.443h-3.094v2.202c0 1.52.918 3.793 3.444 3.793.39.005 1.692.173 1.725 1.993.02 1.14-.224 1.983-.72 2.5-.47.49-1.22.74-2.236.74-.97 0-1.717-.272-2.212-.813-.86-.942-.786-2.442-.785-2.458L-2.94 2.5-6 2.67v.86C-6 8.3-2.9 10 0 10s6-1.7 6-6.47C6 .155 1.725-1.527 1.54-1.595l-.308-.057c-.152 0-.19-.043-.206-.056-.093-.1-.146-.363-.144-.513v-2.22zM.882-6.785H-2.16V-10H.88z" />
            </symbol>
            <g>
                <use xlinkHref="#a" width="12" height="20" x="-6" y="-10" transform="matrix(.3714 0 0 -.3714 6.61 6.606)" overflow="visible" />
                <path d="M6.5 1.14c3.02 0 5.474 2.455 5.474 5.472 0 3.02-2.454 5.473-5.474 5.473-3.017 0-5.474-2.455-5.474-5.473 0-3.017 2.457-5.473 5.474-5.473M6.5.11c-3.59 0-6.5 2.91-6.5 6.5s2.91 6.5 6.5 6.5 6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5z" />
            </g>
        </SvgIcon>
    );
}

ContactWidgetHelp.defaultProps = {
    viewBox: '0 0 13 16'
};

export default ContactWidgetHelp;
